import { Component } from '@angular/core';

@Component({
  selector: 'language-experties',
  standalone: true,
  imports: [],
  templateUrl: './language-experties.component.html',
  styleUrl: './language-experties.component.scss'
})
export class LanguageExpertiesComponent {

}
